import { Stack, Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

interface RoomDetectionUnsuccessfulModalProps {
    onContinue: () => void;
    onUploadNewLayout: () => void;
}

export function RoomDetectionUnsuccessfulModal({ onContinue, onUploadNewLayout }: RoomDetectionUnsuccessfulModalProps) {
    return (
        <BaseDialog
            onClose={onContinue}
            title={ts('room_detection_unsuccessful', 'Room detection unsuccessful')}
            titleColor={theme.palette.error.main}
            cancelLabel={ts('continue_button_label', 'Continue')}
            actionLabel={ts('room_detection_upload_new_layout', 'Upload new layout')}
            onAction={onUploadNewLayout}
        >
            <Stack spacing={2} sx={{ textAlign: 'center', mx: 'auto', maxWidth: 450 }}>
                <Typography>
                    {ts('room_detection_unsuccessful_body', 'We did not find any walls, doors, or windows in the uploaded layout.')}
                </Typography>
                <Typography>
                    {ts('room_detection_unsuccessful_question', 'Would you like to continue with this and draw manually, or upload a new layout?')}
                </Typography>
            </Stack>
        </BaseDialog>
    );
}